// extracted by mini-css-extract-plugin
export default {"container":"Trim_container__hY9Hx","productListContainer":"Trim_productListContainer__cYwfN","productGrid":"Trim_productGrid__4+tTf"};